import { CoreApi } from '@framework/utils/core-api';
import { API_ENDPOINTS } from '@framework/utils/endpoints';
import { ShopsQueryOptionsType } from '@framework/types';

type ReviewShopType = {
  shop_id: number | string;
  order_id: number | string;
  rate_price: number | string;
  rate_order: number | string;
  rate_return_goods: number | string;
};
class Shop extends CoreApi {
  constructor(_base_path: string) {
    super(_base_path);
  }

  all(params: ShopsQueryOptionsType) {
    const {page, locale, limit, categoryIds, orderId, industryIds, shopName, shopIds} = params

    return this.http.get(this._base_path, {
      params: {
        page: page,
        limit: limit || API_ENDPOINTS.DEFAULT_SHOPS_PER_PAGE,
        categoryIds: categoryIds || [],
        orderId,
        shopName,
        industryIds: industryIds || [],
        shopIds : shopIds || '',
      }
    })
    .then((res) => res.data)
    .catch(() => []);
  }

  findBy(slug: string, locale: string) {
    return this.http.get(`${this._base_path}/${slug}`)
      .then((res) => res.data);
  }

  voteWishlistsShop(input: {shop_id: string | number;}) {
    return this.http
      .post(API_ENDPOINTS.VOTE_WISHLISTS_SHOP, input)
      .then((res) => res.data);
  }

  reviewShop(input: ReviewShopType) {
    return this.http
      .post(API_ENDPOINTS.REVIEW_SHOP, input)
      .then((res) => res.data);
  }

  fetchTopShop(limit: number | string = 3, locale: string) {
    return this.http
      .get(`${API_ENDPOINTS.FETCH_TOP_SHOP}/${limit}`)
      .then((res) => res.data)
      .catch(() => []);;
  }

  fetchShopOrder(orderId: number | string, locale: string) {
    return this.http
    .get(API_ENDPOINTS.GET_SHOP_IN_ORDER, {
      params: { order_id: orderId }
    })
    .then((res) => res.data)
    .catch(() => []);;
  }
}

export const ShopNewsService = new Shop(API_ENDPOINTS.FETCH_NEW_SHOPS);
export const BestShopsService = new Shop(API_ENDPOINTS.FETCH_BEST_SHOPS);
export const ShopsService = new Shop(API_ENDPOINTS.SHOPS);
export const ShopDetailService = new Shop(API_ENDPOINTS.FETCH_DETAIL_SHOP);
export const FavoritesShopsService = new Shop(API_ENDPOINTS.FETCH_WISHLISTS_SHOPS)
export const ShopCommonService = new Shop('shops');
export const ShopMenuService = new Shop(API_ENDPOINTS.SHOP_MENU)
